import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, UserPlus } from "lucide-react";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import { setAccessToken } from "../../api/axiosInstance";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import { handleApiValidationError } from "../../utils/apiErrorHandler";

function ForgotPasswordCanvas() {
  useAlphabeticInput();
  const navigate = useNavigate();

  const INITIAL_FORM_DATA = {
    email: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [errors, setErrors] = useState({});
  const [general, setGeneral] = useState("");
  const [loading, setLoading] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isValidEmail = emailRegex.test(formData.email);

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Please Enter Email Address";
    } else if (!isValidEmail) {
      newErrors.email = "Please enter a valid email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!validate()) {
      setLoading(false);
      return;
    }

    try {
      const res = await userAPI.forgotPassword(formData);

      if (res.code === 200) {
        setGeneral(res.message);
        setFormData(INITIAL_FORM_DATA);
      }
    } catch (err) {
      handleApiValidationError(err, setErrors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="custom-login-wrapper">
        <Container fluid className=" p-0">
          <Row className="g-0 ">
            {/* Left Side: Editorial Image */}
            <Col md={6} lg={7} className="d-none d-md-block">
              <div className="custom-login-visual">
                <div className="custom-login-visual-content"></div>
              </div>
            </Col>

            {/* Right Side: Login Form */}
            <Col
                          xs={12}
                          md={6}
                          lg={5}
                          className="d-flex align-items-center justify-content-center bg-white"
                        >
              <div className="custom-login-container">

                <div className="custom-login-header mb-3">
                  <h2 className="custom-login-heading">Forgot Password</h2>
                  <p className="custom-login-subheading">
                  Enter your email to Reset Password
                  </p>
                </div>


                <Form method="post"  className="custom-login-form" onSubmit={handleSubmit}>
                  <Form.Group className="custom-login-field mb-3" controlId="email">
                    <Form.Label className="custom-login-label">
                      Email Address <span className="text-danger">*</span>
                    </Form.Label>
                    <div className="custom-login-input-box">
                      <Mail size={18} className="custom-login-icon" />
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Email Address"
                         className="custom-login-input"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    {errors && errors.email && (
                      <span className="text-danger  custom-input-span-text">
                        {errors.email}
                      </span>
                    )}
                  </Form.Group>

                  <Button
                    className="custom-login-submit w-100 py-3"
                    type="submit"
                  >
                    {loading ? "Sending..." : "SEND RESET LINK"}
                  </Button>

                  {general && (
                    <span className="fw-medium mt-2 text-success">
                      {general}
                    </span>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default ForgotPasswordCanvas;
